import { win } from '../window.js';
import { reusable } from './convincely.js';
const appConf = {};
export const globalConf = reusable('conf', {
    consumer: {},
    consumerCaches: {},
});
const appName = appConf.$appName;
const mainConf = (globalConf.consumer[appName] ??= appConf);
if (mainConf !== appConf) {
    for (const key of Object.keys(appConf)) {
        mainConf[key] ??= appConf[key];
    }
}
const pageConf = win.convincely_conf;
if (typeof pageConf === 'object') {
    Object.assign(mainConf, pageConf[appName] || pageConf);
}
export const conf = mainConf;
/**
 * Global Confs - with multi app support
 *  1. `globalConf` will persist as the same object through multiple apps
 *  2. `globalConf.consumer` will contain app-level confs with the `$appName` being the key
 *     `$appName` is derived and the same as the folder it was uploaded to S3 at the time of pipelines build.
 *  3. `appConf.app` can only be defined once in app-level `core.js` file, this allows it to persist.
 *      all other app-level conf will be overwritten which allows feature toggle specific confs.
 *  4. `globalConf.consumerCaches` contains caches for different apps.
 *      This allows loading resources from many locations as defined in their app-level confs.
 */
//# sourceMappingURL=conf.js.map